import React, { useContext, Suspense } from 'react';
import { MenuAccessContext } from '../utility/getRoles';

const CheckPermissions = ({ element, requiredAccess, ...rest }) => {
  const { menuAccess } = useContext(MenuAccessContext);
  const hasAccess = menuAccess?.some(
    (menu) =>
      menu.menuName === requiredAccess ||
      menu.submenus?.some((submenu) => submenu.submenuName === requiredAccess),
  );
  return hasAccess ? <Suspense fallback={<div style={{ marginLeft: "20px" }}>Loading...</div>}>{element}</Suspense> : (<>You dont have access to this page.</>)
};

export default CheckPermissions;
